import { DateTime } from 'luxon'

import { KanbanStateCourtyard } from './../../types/kanban'
import type { Courtyard } from '../../../@types/entities/entities.types'

import { BookingStatusEnum } from '../../../schemas/enum.schemas'

type CourtyardKanbanFormatProps = Courtyard & {
  courtyard_parking_services_description: string
}

function formatCourtyard(courtyard: Courtyard) {
  // let dwell_time_formatted = ''

  // if (courtyard.end_hours) {
  //   const dwell_time =
  //     DateTime.fromISO(courtyard.end_hours).toSeconds() -
  //     DateTime.fromISO(courtyard.start_hours).toSeconds()

  //   const [hour, minute] = DateTime.fromISO(
  //     DateTime.fromSeconds(dwell_time).toString(),
  //     {
  //       zone: 'America/Sao_Paulo',
  //       locale: 'pt-BR',
  //     }
  //   )
  //     .toLocaleString(DateTime.TIME_24_SIMPLE)
  //     .split(':')

  //   dwell_time_formatted = DateTime.fromISO(courtyard.start_hours, {
  //     zone: 'America/Sao_Paulo',
  //     locale: 'pt-BR',
  //   })
  //     .plus({ hour: Number(hour), minute: Number(minute) })
  //     .toLocaleString(DateTime.TIME_24_SIMPLE)
  // }

  return {
    ...courtyard,
    finish_date_formatted: DateTime.fromISO(courtyard.end_hours, {
      zone: 'America/Sao_Paulo',
      locale: 'pt-BR',
    }).toFormat('dd/MM/yyyy - HH:mm'),
    entry_time_formatted: DateTime.fromISO(courtyard.start_hours, {
      zone: 'America/Sao_Paulo',
      locale: 'pt-BR',
    }).toLocaleString(DateTime.TIME_24_SIMPLE),
    dwell_time_formatted: DateTime.fromISO(courtyard.end_hours, {
      zone: 'America/Sao_Paulo',
      locale: 'pt-BR',
    }).toLocaleString(DateTime.TIME_24_SIMPLE),
    sub_total_formatted: Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(+courtyard.value),
  }
}

export function formatCourtyardKanban(
  courtyards: CourtyardKanbanFormatProps[]
): KanbanStateCourtyard {
  const pending = courtyards
    .filter(item => [BookingStatusEnum.enum.PENDING].includes(item.status))
    .map(item => formatCourtyard(item))
    .sort(
      (a, b) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    )

  const in_progress = courtyards
    .filter(item =>
      [
        BookingStatusEnum.enum.INPROGRESS,
        BookingStatusEnum.enum.ACCEPTED,
      ].includes(item.status)
    )
    .map(item => formatCourtyard(item))
    .sort(
      (a, b) =>
        new Date(b.start_hours).getTime() - new Date(a.start_hours).getTime()
    )

  const finished = courtyards
    .filter(item =>
      [
        BookingStatusEnum.enum.FINISHED,
        BookingStatusEnum.enum.REFUSED,
      ].includes(item.status)
    )
    .map(item => formatCourtyard(item))
    .sort(
      (a, b) =>
        new Date(b.end_hours).getTime() - new Date(a.end_hours).getTime()
    )

  return {
    columns: {
      [BookingStatusEnum.enum.PENDING]: {
        id: BookingStatusEnum.enum.PENDING,
        title: 'Pendente',
        courtyards: pending,
      },
      [BookingStatusEnum.enum.INPROGRESS]: {
        id: BookingStatusEnum.enum.INPROGRESS,
        title: 'Em andamento',
        courtyards: in_progress,
      },
      [BookingStatusEnum.enum.FINISHED]: {
        id: BookingStatusEnum.enum.FINISHED,
        title: 'Finalizadas',
        courtyards: finished,
      },
    },
    columnOrder: [
      BookingStatusEnum.enum.PENDING,
      BookingStatusEnum.enum.INPROGRESS,
      BookingStatusEnum.enum.FINISHED,
    ],
  }
}
